import { FC } from 'react'
import { getShortURL, sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

type Props = {
  text: string
  isLink?: boolean
  logo?: React.SVGProps<SVGElement>
}

export const UserDetailHeaderGeneralInfoItem: FC<Props> = ({ text, isLink = false, logo }) => {
  return (
    <div className={styles.container}>
      <div className={styles.logo}>{logo}</div>
      {isLink ? (
        <a href={sanitizeUrl(text)} className={styles.link} target='_blank' rel='nofollow noopener noreferrer'>
          {getShortURL(text)}
        </a>
      ) : (
        <p className={styles.text}>{text}</p>
      )}
    </div>
  )
}
